<template>
  <t-layout :showNav="false">
    <div class="debug" @click="clearToken">清除token</div>
    <div class="page">
      <div class="banner" @click="toRule">
        <img
          src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/lottery-banner-v2.png"
        />
      </div>

      <div class="main">
        <div class="barrage" v-if="barrageList && barrageList.length">
          <swiper class="barrage-swiper" :options="swiperOption" ref="myBarrageSwiper">
            <swiper-slide class="item" v-for="(item, index) in barrageList" :key="index"
              ><div class="inner ellipsis">{{ item }}</div></swiper-slide
            >
          </swiper>
        </div>

        <div v-if="!!lotteryInfo" class="lottery-info" @click="toNotice">
          <div class="title">
            <span>福彩双色球第{{ lotteryInfo.issue }}期</span>{{ lotteryInfo.data }}
          </div>
          <div class="lottery-number">
            <div
              class="item"
              :class="index == lotteryInfo.stakes.length - 1 ? 'blue' : ''"
              v-for="(item, index) in lotteryInfo.stakes"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div class="tips">
            <div class="info">每周二、四、日 21.15开奖</div>
            <div class="entry">历史开奖</div>
          </div>
        </div>

        <div class="lottery-list" v-if="lotteryList && lotteryList.length">
          <div
            class="item"
            v-for="(item, index) in lotteryList"
            :key="index"
            @click="toExchange(item)"
          >
            <div class="icon">
              <img :src="item.img" />
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="sub-title">{{ item.points_text }}</div>
            </div>
            <div class="action">
              <div class="btn">立即兑换</div>
            </div>
          </div>
        </div>
      </div>

      <div class="fix-right">
        <div class="button" @click="toAssociation"></div>
      </div>

      <div class="fix-bottom">
        <div class="btn" @click="toList">我的兑换</div>
      </div>
    </div>

    <div
      v-if="!userInfo || (userInfo && !userInfo.mobile)"
      class="login_mask"
      @click="toggleBindMobile"
    ></div>
  </t-layout>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'activityLotteryIndex',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        autoplay: true,
        loop: true
      },

      channel: '',

      userInfo: null,

      barrageList: [],
      lotteryInfo: null,
      lotteryList: []
    }
  },
  created() {
    const options = this.$route.query
    if (options.token) {
      let token = decodeURIComponent(options.token)
      localStorage.setItem('token', token)
    }
    if (options.channel) {
      let channel = options.channel || ''
      this.channel = channel
    }

    this.$store.commit('setTitle', '积分换彩')

    this.getUserInfo()
    this.getBoardcastList()
    this.getLotteryInfo()
    this.getLotteryCouponList()
  },

  activated() {},
  methods: {
    clearToken() {
      localStorage.removeItem('token')
    },

    toggleBindMobile() {
      this.$eventBus.$emit('haddleLogin')
    },

    getUserInfo() {
      this.$api.user.getUserInfo().then(res => {
        if (res.data.code == 0) {
          this.userInfo = res.data.data.user_info
        }
      })
    },

    getBoardcastList() {
      this.$api.lotteryPoints.lotteryPointsWinList().then(res => {
        if (res.data.code == 0) {
          this.barrageList = res.data.data.list || []
        }
      })
    },

    getLotteryInfo() {
      this.$api.lotteryPoints.lotteryAnnouncementList({ lottery_id: 1 }).then(res => {
        if (res.data.code == 0) {
          let lotteryInfo = res.data.data[0] || null
          this.lotteryInfo = lotteryInfo
        }
      })
    },

    getLotteryCouponList() {
      this.$api.lotteryPoints.lotteryCouponList({}).then(res => {
        if (res.data.code == 0) {
          const lotteryList = res.data.data.list || []

          this.lotteryList = lotteryList
        }
      })
    },

    toExchange(item) {
      const { channel, userInfo } = this

      if (item.type == 1) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner'
        })

        this.$api.lotteryPoints
          .lotteryChangyouPointAuth({
            mobile: userInfo.mobile,
            filedMsg: channel
          })
          .then(res => {
            if (res.data.code == 0) {
              let { tokenId, type } = res.data.data
              // type = 'B007'
              if (type == '0000') {
                this.$router.push({
                  path: `/activity/lottery/main?channel=${channel}`
                })
              } else {
                this.$router.push({
                  path: `/activity/lottery/bind?channel=${channel}&mobile=${
                    userInfo.mobile
                  }&tokenId=${encodeURIComponent(tokenId)}&type=${type}`
                })
              }
              this.$toast.clear()
            } else {
              this.$toast.clear()
              this.$toast({
                duration: 3000,
                message: res.data.msg || '未知错误'
              })
            }
          })
      }
    },

    toRule() {
      this.$router.push({
        path: '/find/page?id=3163'
      })
    },

    toNotice() {
      this.$router.push({
        path: `/lottery/notice`
      })
    },

    toAssociation() {
      this.$router.push({
        path: '/find/page?id=115'
      })
    },

    toList() {
      this.$router.push({
        path: `/activity/lottery/list`
      })
    }
  }
}
</script>
<style lang="less" scoped>
.debug {
  position: fixed;
  right: 10rpx;
  bottom: 10rpx;
  z-index: 999999;
  padding: 5px 10px;
  background: green;
  color: #fff;
  font-size: 24rpx;
  line-height: 24rpx;
  display: none;
}

.page {
  color: #353738;
  background: #f9fafb;
  padding-bottom: 200rpx;
  min-height: 100vh;
}

.banner {
  width: 100%;
  height: 348rpx;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main {
  padding: 20rpx;

  .barrage {
    width: 100%;
    height: 64rpx;
    overflow: hidden;
    border-radius: 8rpx;
    background: #fff;
    padding-left: 60rpx;
    background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/laba.png');
    background-position: 16rpx 16rpx;
    background-repeat: no-repeat;
    background-size: 32rpx 32rpx;
    margin-bottom: 24rpx;

    .barrage-swiper {
      width: 100%;
      height: 100%;

      .item {
        height: 100%;
        .inner {
          width: 100%;
          font-size: 26rpx;
          line-height: 66rpx;
        }
      }
    }
  }

  .lottery-info {
    padding: 40rpx 24rpx 36rpx;
    background: #fff;
    border-radius: 8rpx;
    margin-bottom: 24rpx;

    .title {
      color: #a1a7ad;
      font-size: 26rpx;
      line-height: 26rpx;
      margin-bottom: 32rpx;

      span {
        font-size: 30rpx;
        line-height: 30rpx;
        font-weight: 500;
        margin-right: 8rpx;
        color: #353738;
      }
    }

    .lottery-number {
      display: flex;
      margin-bottom: 30rpx;

      .item {
        width: 60rpx;
        height: 60rpx;
        border-radius: 60rpx;
        background: linear-gradient(325deg, #f93434 20.42%, #ff7759 88.58%);
        color: #fff;
        line-height: 60rpx;
        text-align: center;
        margin-right: 16rpx;
        font-weight: 30rpx;
        font-weight: 500;

        &.blue {
          background: linear-gradient(325deg, #027bdb 20.42%, #3dc5ff 88.58%);
        }
      }
    }

    .tips {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26rpx;
      color: #a1a7ad;

      .entry {
        padding-right: 40rpx;
        background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/right-arrow.png');
        background-position: right center;
        background-repeat: no-repeat;
        background-size: 32rpx 32rpx;
      }
    }
  }

  .lottery-list {
    .item {
      margin-bottom: 24rpx;
      width: 100%;
      padding: 24rpx;
      border-radius: 8rpx;
      background: #fff;
      display: flex;
      align-items: center;

      .icon {
        width: 150rpx;
        height: 150rpx;
        margin-right: 16rpx;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }

      .info {
        flex: 1;

        .title {
          font-size: 30rpx;
          line-height: 30rpx;
          margin-bottom: 46rpx;
        }

        .sub-title {
          color: #ff5566;
          font-size: 26rpx;
          line-height: 26rpx;
        }
      }

      .action {
        padding-top: 50rpx;
        .btn {
          width: 146rpx;
          height: 52rpx;
          border-radius: 26rpx;
          background: #ff5566;
          text-align: center;
          line-height: 52rpx;
          color: #fff;
          font-size: 26rpx;
        }
      }
    }
  }
}

.fix-right {
  width: 236rpx;
  height: 88rpx;
  position: fixed;
  z-index: 9;
  right: 0;
  bottom: 224rpx;
  background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/right-btn.png');
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .button {
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}

.fix-bottom {
  width: 100%;
  padding-bottom: 12rpx;
  background: #fff;
  position: fixed;
  z-index: 9;
  right: 0;
  bottom: 0;

  .btn {
    height: 108rpx;
    text-align: center;
    font-size: 34rpx;
    font-weight: 500;
    line-height: 108rpx;
  }
}
</style>
